export interface NoteDTO {
    id: number;
    calendarId: number;
    eventId: string;
    title: string;
    stringText: string;
    noteType: string;
    archived: boolean;
    recurring: boolean;
    participants: string;
    hiddenTag: string;
    deleted: boolean;
    parentNoteId: number;
    parentNoteName: string;
    endDate: Date;
    uuid: string;
    lastModifiedTime: number;
    notes: NoteDTO[];
    dirty: boolean;
    version: number;
    systemFolder: boolean;
}

export interface HisNoteDTO {
    id: number;
    calendarId: number;
    eventId: string;
    title: string;
    stringText: string;
    noteType: string;
    archived: boolean;
    recurring: boolean;
    participants: string;
    hiddenTag: string;
    deleted: boolean;
    parentNoteId: number;
    parentNoteName: string;
    endDate: Date;
    uuid: string;
    lastModifiedTime: number;
    systemFolder: boolean;
}

export interface NoteWriteDTO {
    calendarId: number;
    eventId: string;
    title: string;
    stringText: string;
    noteType: string;
    archived: boolean;
    recurring: boolean;
    participants: string;
    hiddenTag: string;
    deleted: boolean;
    parentNoteId: number;
    endDate: Date;
    uuid: string;
    lastModifiedTime: number;
    version: number;
}

export function createNote(calendarId: number,
    eventId: string,
    title: string,
    stringText: string,
    noteType: string,
    archived: boolean,
    recurring: boolean,
    participants: string,
    hiddenTag: string,
    deleted: boolean,
    parentNoteId: number,
    endDate: Date,
    uuid: string,
    lastModifiedTime: number,
    version: number
) {
    return {
        calendarId: calendarId, eventId: eventId, title: title, stringText: stringText, noteType: noteType, archived: archived,
        recurring: recurring, participants: participants, hiddenTag: hiddenTag, deleted: deleted, parentNoteId: parentNoteId, endDate: endDate,
        uuid: uuid, lastModifiedTime: lastModifiedTime, version: version
    };
}

export function createNewNote(calendarId: number,
    noteType: string,
    parentNoteId: number,
) {
    return {
        id: -1, calendarId: calendarId, eventId: null, title: '', stringText: '', noteType: noteType, archived: false,
        recurring: false, participants: null, hiddenTag: null, deleted: false, parentNoteId: parentNoteId, parentNoteName: '', endDate: null,
        uuid: null, lastModifiedTime: null, notes: [], dirty: true, version: 0, systemFolder: false
    };
}
